/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SloCheckDto
 */
export interface SloCheckDto {
    /**
     * 
     * @type {string}
     * @memberof SloCheckDto
     */
    checkId?: string;
    /**
     * 
     * @type {string}
     * @memberof SloCheckDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SloCheckDto
     */
    passed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SloCheckDto
     */
    actual?: string;
    /**
     * 
     * @type {string}
     * @memberof SloCheckDto
     */
    target?: string;
}

/**
 * Check if a given object implements the SloCheckDto interface.
 */
export function instanceOfSloCheckDto(value: object): value is SloCheckDto {
    return true;
}

export function SloCheckDtoFromJSON(json: any): SloCheckDto {
    return SloCheckDtoFromJSONTyped(json, false);
}

export function SloCheckDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SloCheckDto {
    if (json == null) {
        return json;
    }
    return {
        
        'checkId': json['checkId'] == null ? undefined : json['checkId'],
        'description': json['description'] == null ? undefined : json['description'],
        'passed': json['passed'] == null ? undefined : json['passed'],
        'actual': json['actual'] == null ? undefined : json['actual'],
        'target': json['target'] == null ? undefined : json['target'],
    };
}

export function SloCheckDtoToJSON(json: any): SloCheckDto {
    return SloCheckDtoToJSONTyped(json, false);
}

export function SloCheckDtoToJSONTyped(value?: SloCheckDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkId': value['checkId'],
        'description': value['description'],
        'passed': value['passed'],
        'actual': value['actual'],
        'target': value['target'],
    };
}

